import React, { useContext, useEffect, useState } from "react";
import styles from "../../pages/dashboard/CourseCategory.module.css";
import red_undeline from "../../img/dashboard/Red Underline (1).png";
import separator_pattern_right from "../../img/dashboard/Bottom Separator Pattern - Right (1).png";
import CardTemplate from "../../shared/Component/BackOffice/BookModule/CardTemplate";
import PaginationTop10 from "./PaginationTop10";
import toast from "react-hot-toast";
import { AxiosInstance } from "../../axios";
import moment from "moment";
import { WishListContext } from "../../context/WishListItems";
import { CartContext } from "../../context/CartItems";
import { useNavigate } from "react-router-dom";

const BestSellers = () => {
  const navigate = useNavigate();
  const [fullData, setFullData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    userid = user?.user_id || null;
  }
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const itemsPerPage = 8; // Items per page
  const currentData =
    fullData.length > 0
      ? fullData.slice(
          currentPage * itemsPerPage,
          (currentPage + 1) * itemsPerPage
        )
      : [];

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(fullData.length / itemsPerPage) - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    loadListdata();
  }, []);

  const loadListdata = async () => {
    setIsLoading(true);
    try {
      const res = await AxiosInstance.post("/api/book/view_all_books", {
        user_id: userid,
        search: "",
        view_all_book: 1,
        popularity: 3, // default for best sellers
        category_id: "",
        group_course_id: "",
        subject_id: "",
        medium: "",
        is_set: "",
        tag_id: "",
        book_id: "",
        is_combo_offer: "",
        is_ebook: "",
        book_type: "",
      });
      if (res.data.status) {
        setFullData(res.data.data.slice(-24));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while fetching data.");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleWishlist = (bookId, currentStatus) => {
    const payload = {
      user_id: userid,
      book_id: bookId,
      is_favorite: currentStatus == 1 ? 0 : 1,
      created_by: userid,
      created_dt: moment().format("YYYY-MM-DD"),
    };

    AxiosInstance.post("/api/book/wishlist/add", payload)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          loadListdata();
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        console.error("Error updating wishlist:", error);
      });
  };

  const handleAddCart = async (bookIds) => {
    try {
      const res = await AxiosInstance.post("/api/book/cart/add", {
        id: "",
        user_id: userid,
        book_id: bookIds,
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userid,
      });
      if (res.data.status) {
        toast.success(res.data.message);
        loadListdata();
        cartNotify(userid);
      } else {
        toast.error(res.data.message);
        sessionStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const handleTagsFilter = (id, tagName) => {
    const newTag = [{ id, name: tagName, type: "selectedTags" }];
    setSelectedTags(newTag);
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        categoryId: "",
        category_name: "",
        course_name: "",
        medium_name: "",
        courseId: "",
        mediumId: "",
        search: "",
        series_value: "",
        SELECTEDTAGS: newTag,
      },
    });
  };

  return (
    <>
      <div className="m-lg-4 m-3">
        <h3 className={`${styles.courseTitle} text-center position-relative`}>
          Our B
          <span>
            <img
              className={`${styles.course_underline_img}`}
              src={red_undeline}
              alt="word_underline"
            />
          </span>
          estsellers
        </h3>
        <p className={`${styles.subtitle}`}>
          Top picks to boost your exam preparation. Don't miss out on the most
          popular books!
        </p>
        <div className={`row mx-0 mt-5`}>
          {currentData.length > 0 &&
            currentData.map((item, index) => (
              <div className="col-lg-3 col-12 mb-2" key={index}>
                <CardTemplate
                  items={item}
                  toggleWish={toggleWishlist}
                  handleSubmitCart={handleAddCart}
                  ///
                  tagsFilter={selectedTags}
                  handleTagsFilter={handleTagsFilter}
                />
              </div>
            ))}
        </div>
        {/* Pass showViewAllButton as true */}
        {currentData.length > 0 && (
          <PaginationTop10
            totCount={Array.from({
              length: Math.ceil(fullData.length / itemsPerPage),
            })}
            currentPage={currentPage}
            hPrev={handlePrev}
            hNext={handleNext}
            onPageChange={setCurrentPage}
            showViewAllButton={true}
          />
        )}
      </div>
      <div
        className={`${styles.separator_pattern_right} d-flex justify-content-end my-lg-5 my-4`}
      >
        <img
          src={separator_pattern_right}
          alt="separator_pattern_right"
          className={`${styles.separator_pattern_right}`}
          style={{ width: "50%", height: "auto", objectFit: "cover" }}
        />
      </div>
    </>
  );
};

export default BestSellers;
